import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import HeaderBar from '../../components/HeaderBar/HeaderBar'
import SearchBox from './Search/SearchBox'
import ResultsBox from './Results/Results'

export const DataGroupsPage: React.FC = () => {
    return (
        <Container fluid={true} className='wivi-container'>
            <Row>
            <Col xs={12}>
                <HeaderBar
                    origin='Data Archive'
                    routes={[
                        {
                            title: 'Data Groups'
                        }
                    ]}
                    help={{ title: 'Data Groups', text: '' }}
                />
            </Col>
            </Row>
            <Row>
                <SearchBox />
            </Row>
            <Row>
                <ResultsBox />
            </Row>
        </Container>
    )
}

export default DataGroupsPage
